import axios from "axios";
import { BASE_API_URL, isLocalhost } from "../../config/config";

const apiClient = axios.create({
    baseURL: BASE_API_URL,
    headers: {
        "Content-Type": "application/json",
    },
    withCredentials: true, // Include credentials by default
});

// Add an interceptor to attach tokens automatically
apiClient.interceptors.request.use(
    (config) => {
        const accessToken = localStorage.getItem("accessToken");
        if (accessToken) {
            config.headers["Authorization"] = `Bearer ${accessToken}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

apiClient.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && error.response.status === 401) {
            const isLoginPage = /^\/login(\?.*)?$/.test(
                window.location.pathname.toLowerCase() + window.location.search.toLowerCase()
            );
            if (!isLoginPage) {
                if (isLocalhost) {
                    window.location.href = "/login";
                    sessionStorage.removeItem("loggedIn");
                } else {
                    window.location.reload();
                }
            }
        }
        return Promise.reject(error);
    }
);

export default apiClient;
